import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=ff20dfa2"
import script from "./pass.vue?vue&type=script&lang=js"
export * from "./pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports